import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaRegCopy } from 'react-icons/fa';

interface BlogPostDisplayProps {
  title: string;
  content: string;
  wordCount: number;
}

export const BlogPostDisplay: React.FC<BlogPostDisplayProps> = ({
  title,
  content,
  wordCount
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = () => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = `<h1>${title}</h1>${content}`;
    document.body.appendChild(tempDiv);
    
    const range = document.createRange();
    range.selectNodeContents(tempDiv);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
    }
    
    document.body.removeChild(tempDiv);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="mt-4 p-4 border rounded bg-white"
      style={{
        backgroundColor: "#fff",
        overflowX: "hidden", // Prevent horizontal overflow
        boxSizing: "border-box", // Include padding in width
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: title }} />
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <p className="mt-3 text-muted">
        <strong>Word Count:</strong> {wordCount}
      </p>
      <div className="d-flex align-items-center mt-3 flex-column flex-sm-row">
        <Button
          variant="outline-secondary"
          onClick={handleCopy}
          className="mb-2 mb-sm-0 w-100 w-sm-auto"
        >
          <FaRegCopy className="me-2" /> Copy
        </Button>
        {copied && <span className="ms-0 ms-sm-2 text-success">Copied!</span>}
      </div>
    </div>
  );
};